import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  btns: {
    ...dFlex('end'),
    gap: 16,
  },
  token: {
    ...dFlex('start'),
    gap: 4,
  },
  inner: {
    ...dFlex('initial'),
    flexDirection: 'column',
    gap: 24,
  },
}));

export default useStyles;
